
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-place-of-birth"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-place-of-birth"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
   </div> 



  <div class="edit-nationality-body">
    <label class="dob-label"> Place Of Birth </label>
    <div class="cannot-edit-profile-rectangle">
     
        <input sanitizeInputForm type="text" matInput
        [formControl]="dialogData.addPlaceOfBirthFormControl"
        maxlength="100"       
        (input)="dialogData.onInputPlaceofBirth()"
      />
     
    </div>

    <div class="btn-container nationality-button">
      <button tabindex="0" role="button" aria-label="save" class="send-button" (click)="dialogData.savePlaceOfBirthDetails()" >
        Save
      </button>
    </div>
  </div>


</div>
</div>


